import AdresseAdresse1 from '@/generated/controls/adresse/AdresseAdresse1.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: AdresseAdresse1
})
